import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Loader from "../components/common/Loader";
import ErrorState from "../components/common/ErrorState";
import EmptyState from "../components/common/EmptyState";
import applicationStatusService from "../services/applicationStatusService";

const OVERALL_FIELDS = [
  { key: "applied", label: "Applied" },
  { key: "in_process", label: "In process" },
  { key: "shortlisted", label: "Shortlisted" },
  { key: "selected", label: "Selected" },
  { key: "rejected", label: "Not selected" },
];

export default function HiringFunnel() {
  const [campuses, setCampuses] = useState([]);
  const [state, setState] = useState("loading");

  function load() {
    setState("loading");
    applicationStatusService
      .campusFunnel()
      .then((res) => {
        setCampuses(res.data || []);
        setState((res.data || []).length ? "ready" : "empty");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, []);

  return (
    <div className="pm-page">
      <header className="pm-page__header">
        <div>
          <span className="pm-eyebrow">Hiring status</span>
          <h1>Funnel by campus</h1>
        </div>
      </header>

      {state === "loading" && <Loader label="Loading hiring funnel" />}
      {state === "error" && <ErrorState onRetry={load} />}
      {state === "empty" && <EmptyState title="No campuses yet" description="Add a campus to see its hiring funnel here." />}

      {state === "ready" && (
        <div className="pm-funnel-list">
          {campuses.map((c, i) => {
            const total = Number(c.overall?.total_applicants || 0);
            return (
              <motion.div
                key={c.id}
                className="pm-card pm-funnel-card"
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: Math.min(i, 6) * 0.05 }}
              >
                <div className="pm-funnel-card__head">
                  <h3>{c.name}</h3>
                  <Link to={`/admin/universities/${c.id}/rounds`} className="pm-table__link">Manage rounds →</Link>
                </div>

                <div className="pm-funnel-overall">
                  {OVERALL_FIELDS.map((f) => (
                    <div key={f.key} className="pm-funnel-overall__stat">
                      <strong>{c.overall?.[f.key] || 0}</strong>
                      <span>{f.label}</span>
                    </div>
                  ))}
                </div>

                {!c.rounds?.length ? (
                  <p className="pm-table__muted" style={{ marginTop: 14 }}>No rounds defined for this campus yet.</p>
                ) : (
                  <div className="pm-funnel-rounds">
                    {c.rounds.map((r) => {
                      const roundTotal =
                        Number(r.pending || 0) + Number(r.in_review || 0) + Number(r.shortlisted || 0) +
                        Number(r.waitlisted || 0) + Number(r.rejected || 0);
                      const widthPct = total ? Math.min(100, Math.round((roundTotal / total) * 100)) : 0;

                      return (
                        <div className="pm-funnel-round-row" key={r.id}>
                          <span className="pm-funnel-round-row__label">{r.round_name}</span>
                          <div className="pm-funnel-round-row__track">
                            <motion.div
                              className="pm-funnel-round-row__fill"
                              initial={{ width: 0 }}
                              animate={{ width: `${widthPct}%` }}
                              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                            />
                          </div>
                          <span className="pm-funnel-round-row__count">{roundTotal}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
}
